var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"personal"}},[_c('iframe',{staticClass:"personal-centent",attrs:{"src":_vm.personalUrl,"width":"100%","height":"100%","frameborder":"0","scrolling":"auto"}}),(_vm.maskDisable)?_c('div',{staticClass:"mask"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }